module.exports = __webpack_public_path__ + "static/img/img_b.ab7c3f0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/img_b.jpg
// module id = Jpvo
// module chunks = 2